/* eslint-disable @typescript-eslint/ban-ts-comment */
// @ts-nocheck this gets addressed in upcoming api update phase
import { Collection } from 'core/model/Collection';
import { AssetType, TagValue } from '@kentik/ui-shared/labels/lib';
import AssetTagModel from './AssetTagModel';
import AssetTagValueModel, { AssetTagValueDeserializeJson } from './AssetTagValueModel';

type AssetTagValueSerializeJson = {
  tag_id: string;
  value: string;
  asset_type: string;
  asset_ids: Array<string | number>;
};

class AssetTagValueCollection extends Collection<AssetTagValueModel> {
  removedIds = new Set<string | number>();

  assetTagModel: AssetTagModel;

  constructor(data: AssetTagValueModel[] = [], { assetTagModel }: { assetTagModel: AssetTagModel }) {
    super(data);
    this.assetTagModel = assetTagModel;
  }

  get url() {
    return `/api/ui/assetTags/keys/${this.assetTagModel.id}/values`;
  }

  get model() {
    return AssetTagValueModel;
  }

  /**
   * Returns a list entries to be expanded server-side for update.
   * Each item contains the id and value for an asset tag, an asset type, and a list of asset ids of the given asset type
   */
  serialize(): AssetTagValueSerializeJson[] {
    const tag_id = this.assetTagModel.id;

    return this.get().flatMap((valueModel) => {
      const { value } = valueModel.get();

      return Object.values(
        valueModel.mappingCollection.get().reduce(
          (acc, mappingModel) => {
            const { asset_type, asset_id } = mappingModel.get();

            if (!acc[asset_type]) {
              acc[asset_type] = {
                tag_id,
                value,
                asset_type,
                asset_ids: []
              };
            }

            acc[asset_type].asset_ids.push(asset_id);

            return acc;
          },
          {} as Record<string, AssetTagValueSerializeJson>
        )
      );
    });
  }

  /**
   * Returns a list of values with associated asset mappings.
   * These mappings are used to hydrate the mapping collection in each value model.
   */
  deserialize(data: TagValue[]): AssetTagValueDeserializeJson[] {
    return Object.values(
      data.reduce(
        (acc, tagValue) => {
          const { id, asset_type, asset_id, value } = tagValue;

          if (!acc[value]) {
            acc[value] = { id: value, value, mappings: [] };
          }

          acc[value].mappings.push({ id, asset_type: asset_type as AssetType, asset_id });

          return acc;
        },
        {} as Record<string, AssetTagValueDeserializeJson>
      )
    );
  }
}

export default AssetTagValueCollection;
